import { createStateContext } from '@change-corgi/core/react/context';

import { INITIAL_STATE } from './initialState';
import { mutations } from './mutations';
import type { PetitionCommentsPageState } from './types';

export const {
	StateContext: PetitionCommentsPageStateContext,
	StateProvider: PetitionCommentsPageStateContextProvider,
	useStateContext: usePetitionCommentsPageState,
} = createStateContext<
	PetitionCommentsPageState,
	typeof mutations,
	{
		deleteConfirmMessage: boolean;
	}
>({
	name: 'deleteConfirmMessage',
	mutations,
	initialState({ deleteConfirmMessage }) {
		return {
			...INITIAL_STATE,
			deleteConfirmMessage,
		};
	},
});
